<div class="container h-100 d-flex align-items-center p-5" *ngIf="isLoading">
    <mat-spinner [diameter]="60" [strokeWidth]="3" class="mx-auto"></mat-spinner>
</div>

<div class="container p-5" *ngIf="!isLoading">
    <h1 class="mb-0">All users list</h1>
    <h4 class="fw-light mb-0">View your current customers and edit their AI agents</h4>

    <mat-divider class="mt-4 mb-4"></mat-divider>

    <div class="mat-elevation-z8 mx-auto row mt-5">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- First Name Column -->
            <ng-container matColumnDef="First Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
                <td mat-cell *matCellDef="let row"> {{row.firstName}} </td>
            </ng-container>

            <!-- Last Name Column -->
            <ng-container matColumnDef="Last Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
                <td mat-cell *matCellDef="let row"> {{row.lastName}} </td>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="Email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let row"> {{row.email}} </td>
            </ng-container>

            <!-- Has payed Column -->
            <ng-container matColumnDef="Has payed">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Has payed</th>
                <td mat-cell *matCellDef="let row">{{row.paymentSettings && row.paymentSettings.payed ? 'True' :
                    'False'}} </td>
            </ng-container>

            <!-- Has payed Column -->
            <ng-container matColumnDef="View">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>View</th>
                <td mat-cell *matCellDef="let row">
                    <button mat-raised-button color="primary" (click)="onViewUser(row)">Select</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
    </div>
</div>